'use strict';

import Backbone from 'backbone';
import mediator from '../../js/mediator';
import utilities from '../../js/utilities';
import config from '../../js/config';
import analytics from '../Analytics/Analytics';
import { parallelArrayEach } from '../../utilities/uiLoopHelpers';
import { SamtecToolService } from '../../services/SamtecToolService';

let instance = null;

export default class SamtecToolCta extends Backbone.View {

  get events() {
    return {
      'click .SamtecToolCta': 'handleOpenerClicked'
    };
  }

  render() {
    let $samtecButton = this.$el;
    return this.samtecToolService.getProductSeriesOption({ partNumber: this.partId, validatePart: true })
      .then((response) => {
        if (response.isValid && response.series !== null &&
          this.samtecRestrictions !== null && this.samtecRestrictions !== undefined && this.samtecRestrictions !== '' &&
          this.samtecRestrictions.indexOf(response.series.itemSeriesCode) === -1) {
          $samtecButton.removeClass('Pdp-samtec-section');
        }
      });
  }

  initialize() {
    this.samtecToolService = SamtecToolService.getInstance();
    this.partId = '';
    this.getPartId();
    this.getRestrictions();
    this.render();
  }

  /**
   * Handle the click event to open the Samtec page
   *
   * @param {Event} e
   */
  handleOpenerClicked(e) {
    e.preventDefault();
    analytics.pushToEventFramework({
      event: config.analytics.events.click,
      category: config.analytics.categories.productDetail,
      action: config.analytics.actions.click,
      label: config.analytics.labels.modifyThisPart
    });
    SamtecToolCta.getInstance().open({
      partId: this.partId
    });
  }

  open(options) {
    let samtecUrl = document.location.origin + config.urls.samtecPage;
    let openerUrl = utilities.queryStringUrl(samtecUrl, {
      partId: options.partId, vendorPdpId: config.samtecTool.SamtecManufacturerId
    });
    mediator.trigger(config.events.requestPageReload, openerUrl);
  }

  getPartId() {
    let part = this.$el.find('.SamtecToolCta');
    this.partId = part.data('samtecPartid');
  }

  getRestrictions() {
    let part = this.$el.find('.SamtecToolCta');
    this.samtecRestrictions = part.data('samtecRestrictions');
  }

  /**
   * Get the singleton instance of the SamtecToolCta.
   *
   * @returns {SamtecToolCta}
   */
  static getInstance() {
    if (!instance) {
      instance = new SamtecToolCta();
    }

    return instance;
  }

}


export function createSamtecToolCta($parent) {
  let $samtecButton = $parent.find('.Pdp-samtec');
  parallelArrayEach($samtecButton, el => new SamtecToolCta({ el }));
}



// WEBPACK FOOTER //
// ./assets/components/SamtecToolView/SamtecToolCta.js